import { ref } from 'vue'

export const historyStack = []
export const lastRoute = ref(null)
